export default function Hero() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5a8057f8f99238c09efe8aabd98ff0c0.jpg"
          alt="Clean corporate office"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d2218]/85 via-[#0d2218]/60 to-[#0d2218]/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 py-32">
        <div className="max-w-2xl">
          <span
            className="inline-block text-[#4caf7d] text-xs font-semibold tracking-widest uppercase mb-6"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Commercial Cleaning Excellence
          </span>
          <h1
            className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Spotless Spaces.<br />
            <span className="text-[#4caf7d]">Productive</span> Teams.<br />
            Trusted Results.
          </h1>
          <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-lg">
            We deliver premium commercial cleaning solutions tailored for corporate environments. Consistent, reliable, and certified — so your team can focus on what matters.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => handleNav('#services')}
              className="bg-[#4caf7d] text-white font-semibold px-8 py-4 rounded-full hover:bg-[#3d9e6e] transition-colors duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              View Services
            </button>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mt-14">
            {[
              { value: '500+', label: 'Happy Clients' },
              { value: '20+', label: 'Years Experience' },
              { value: '99%', label: 'Satisfaction Rate' },
            ].map((stat) => (
              <div key={stat.label}>
                <div
                  className="text-2xl font-bold text-white"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {stat.value}
                </div>
                <div className="text-white/50 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <div className="w-px h-8 bg-white/30"></div>
        <i className="ri-arrow-down-line text-white/40 text-sm"></i>
      </div>
    </section>
  );
}
